import { QueryKey, useIsFetching } from 'react-query';

export const useIsFetchingQuery = (queryKey: QueryKey) => {
    const fetchCount = useIsFetching(queryKey);

    return fetchCount > 0;
};
